import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import type { GlobalErrorHandler, Budget, Category } from '..'

export class BudgetsApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  addBudget = async (category: Category, amount: number, parentGuid: string | null = null) => {
    return this.fetchInstance
      .post(ApiEndpoints.BUDGETS, {
        amount,
        category_guid: category.guid,
        category_name: category.name,
        parent_guid: parentGuid,
      })
      .then((data) => data.budget)
  }

  deleteBudget = async (guid: string) => {
    return this.fetchInstance.delete(`${ApiEndpoints.BUDGETS}/${guid}`).then((data) => data)
  }

  getBudgets = async () => {
    return this.fetchInstance.get(ApiEndpoints.BUDGETS).then((data) => data.budgets)
  }

  updateBudget = async (budget: Budget) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.BUDGETS}/${budget.guid}`, budget)
      .then((data) => data.budget)
  }

  addMerchantBudget = async (merchantGuid: string, amount: number) => {
    return this.fetchInstance
      .post(ApiEndpoints.MERCHANT_BUDGETS, {
        amount,
        merchant_guid: merchantGuid,
      })
      .then((data) => data.merchant_budget)
  }

  updateMerchantBudget = async (merchantBudgetGuid: string, amount: number) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.MERCHANT_BUDGETS}/${merchantBudgetGuid}`, {
        amount,
      })
      .then((data) => data.merchant_budget)
  }

  deleteMerchantBudget = async (merchantBudgetGuid: string) => {
    return this.fetchInstance
      .delete(`${ApiEndpoints.MERCHANT_BUDGETS}/${merchantBudgetGuid}`)
      .then((data) => data)
  }
}
